import * as React from "react";
import { LayoutDashboard, Fingerprint, MessageSquare, Mail } from "lucide-react";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "@/components/ui/card";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
const integrationCards = [{
  id: "real-time-matching",
  icon: LayoutDashboard,
  title: "REAL-TIME MATCHING",
  description: "Our live radar identifies active food orders in your immediate area, letting you jump in and save instantly.",
  isSimulation: false
}, {
  id: "secure-splitting",
  icon: Fingerprint,
  title: "SECURE COST-SPLITTING",
  description: "Bank-grade encryption ensures your shared payments are processed safely. No more awkward 'who owes what' texts.",
  isSimulation: true
}, {
  id: "intuitive-ui",
  icon: MessageSquare,
  title: "INTUITIVE INTERFACE",
  description: "A minimalist, mobile-first design built for the fast-paced lifestyle of Toronto students and professionals.",
  isSimulation: false
}];
export default function UnifiedExperience() {
  return <section data-section-id="76376" id="engineered-for-efficiency" className="bg-background py-24 w-full dark">
      <div className="container mx-auto px-4 md:px-6 max-w-6xl">
        <div className="mb-16 text-center max-w-2xl mx-auto">
          
          
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {integrationCards.map((card, i) => {
          const Icon = card.icon;
          return <Card key={card.id} data-index={i} className="bg-card rounded-sm border-white/10 shadow-lg flex flex-col h-full overflow-hidden transition-all duration-300 hover:border-primary/50 hover:shadow-[0_0_30px_-10px_rgba(251,146,60,0.3)]">
                <CardHeader className="pb-4">
                  <div className="size-12 rounded-sm bg-primary/10 flex items-center justify-center mb-5">
                    <Icon className="size-6 text-primary" strokeWidth={2} />
                  </div>
                  <CardTitle className="text-foreground text-xl font-black tracking-tight uppercase">
                    {card.title}
                  </CardTitle>
                  <CardDescription className="text-muted-foreground text-base leading-relaxed mt-2 font-medium">
                    {card.description}
                  </CardDescription>
                </CardHeader>

                {card.isSimulation && <CardContent className="mt-auto pt-4 pb-6">
                    <div className="space-y-3 bg-background/40 p-4 rounded-sm border border-white/5 backdrop-blur-md">
                      <div className="relative">
                        <Mail className="absolute left-3 top-1/2 -translate-y-1/2 size-4 text-muted-foreground" />
                        <Input type="email" placeholder="student@utoronto.ca" className="pl-9 bg-card border-white/20 rounded-sm h-10 focus-visible:ring-primary/40 text-sm" readOnly tabIndex={-1} />
                      </div>
                      <Button asChild className="w-full rounded-sm h-10 font-black uppercase tracking-tight bg-primary text-primary-foreground hover:bg-primary/90 shadow-[0_0_15px_rgba(251,146,60,0.2)] transition-all">
                        <Link to="mailto:support@hlaforder.app">Join List</Link>
                      </Button>
                    </div>
                  </CardContent>}
              </Card>;
        })}
        </div>
      </div>
    </section>;
}